/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { AppRoute } from "../../Routes";


export function flattenRoutes(routes: Array<AppRoute>, user_role: string | null) {
  let navRoutes: Array<AppRoute> = [];
  
  for (const route of routes) {
    // Check if the route should be included based on user_role
    const includeRoute = user_role === 'admin' || !route.name?.includes('page.admin');

    if (route.path !== '*' && includeRoute) {
      navRoutes.push(route);
    }

    if (route.children) {
      const children = route.children.map((child) => ({ ...child, path: child.path || route.path }));
      navRoutes = [...navRoutes, ...flattenRoutes(children, user_role)];
    }
  }

  return navRoutes;
}